export default "__VITE_ASSET__3ebd1ca4__"